import script from "./skeletonTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./skeletonTable.vue?vue&type=script&setup=true&lang=ts"

import "./skeletonTable.vue?vue&type=style&index=0&id=c8f3aeac&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8f3aeac"]])

export default __exports__